import { Content } from "_metronic/layout/components/Content"
import { Toolbar } from "_metronic/layout/components/toolbar/Toolbar"
import { PageLink, PageTitle } from "_metronic/layout/core"
import { t } from "i18next"
import { FC, ReactNode } from "react"

interface LoadingIndicatorProps {
    spinnerClass?: string,
    spinnerStyle?: object,
    panelClass?: string;
    panelStyle?: object
}

const LoadingIndicator: FC<LoadingIndicatorProps> = ({
    spinnerClass = '',
    spinnerStyle = { width: '4rem', height: '4rem' },
    panelClass = '',
    panelStyle = {} 
}) => {

    return (

        <div className={`d-flex justify-content-center align-items-center ${panelClass}`} style={panelStyle}>
            <div className={`spinner-border  ${spinnerClass}`} style={spinnerStyle} role="status" aria-hidden="true"></div>
        </div>
    );
};


export { LoadingIndicator }

